import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/recruit',
    element: <RecruitPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;